import { render, staticRenderFns } from "./SidebarProject.vue?vue&type=template&id=e8c25f34&"
import script from "./SidebarProject.vue?vue&type=script&lang=js&"
export * from "./SidebarProject.vue?vue&type=script&lang=js&"
import style0 from "./SidebarProject.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports